import React from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw, Home } from "lucide-react";
import { Button } from "../components/ui/button";
import { BrandLogo } from "../components/BrandLogo";

export default function Cancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh hero-wash">
      <div className="mx-auto max-w-lg px-4 py-10">
        <BrandLogo size={40} withText />
        <div className="mt-6 rounded-[1.2rem] border bg-card p-6 text-center shadow-[var(--shadow-soft)]">
          <h1 className="font-display text-2xl font-semibold" style={{ color: "hsl(var(--brand-brown))" }}>Payment not completed</h1>
          <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))]">No worries! Your photos and choices were saved. You can review and try again.</p>
          <div className="mt-5 flex flex-col gap-2">
            <Button onClick={() => navigate("/create")} data-testid="retry-checkout-button" className="h-11 rounded-xl"><RotateCcw className="mr-1.5 h-4 w-4" /> Review and try again</Button>
            <Button onClick={() => navigate("/")} variant="outline" className="h-11 rounded-xl border bg-white"><Home className="mr-1.5 h-4 w-4" /> Back to home</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
